import { useEffect, useState } from 'react';
import { getReferenceData } from '../api/endpointsBackend';
import { useDisplayCurrency } from '../contexts/DisplayCurrencyContext';
import { usePreferences } from '../contexts/PreferencesContext';
import { resolveHomeCurrency } from '../utils/homeCurrency';

/**
 * The currency whose amounts drop their code on a movement row, resolved as
 * Home resolves it, so a movement reads the same here as on Home. A user who
 * skipped the onboarding country step has no stored home currency, and the
 * app-wide currency list can fail to load: the workspace's reference data
 * stands in for it then. Every phone list of movement rows reads it, so a
 * movement's amount looks the same on every tab.
 */
export default function usePhoneHomeCurrency() {
  const { homeCurrency, country } = usePreferences();
  const { activeCurrencies, displayCurrency } = useDisplayCurrency();
  const [refCurrencies, setRefCurrencies] = useState([]);
  const needRef = !homeCurrency && activeCurrencies.length === 0;
  useEffect(() => {
    if (!needRef) return undefined;
    let active = true;
    getReferenceData()
      .then((ref) => { if (active) setRefCurrencies((ref?.currencies || []).map((c) => c.name)); })
      .catch(() => {});
    return () => { active = false; };
  }, [needRef]);
  const currencies = activeCurrencies.length ? activeCurrencies : refCurrencies;
  return homeCurrency
    || resolveHomeCurrency(country, currencies)
    || displayCurrency
    || currencies[0]
    || null;
}
